import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "flush"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIMultiColumn(props) {
  const {
      children,
      className,
      flush = false
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, other, {
    className: classNames('private-multicolumn', className, flush && 'private-multicolumn--flush'),
    children: children
  }));
}
UIMultiColumn.displayName = 'UIMultiColumn';
UIMultiColumn.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  flush: PropTypes.bool.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIMultiColumn.defaultProps = {
  flush: false
};